<template>
  <v-textarea
    solo
    :tabindex="field.tabIndex"
    :loading="field.loading"
    v-bind="$attrs"
    v-on="$listeners"
    :value="field.value"
  ></v-textarea>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
  name: "TextArea",

  props: ["field"],

  mounted() {},
  computed: {},
  methods: {}
};
</script>
